import { UploadPolicy } from '@libraries/secure-uploader-client';
import { createReducer, on } from '@ngrx/store';
import * as UiActions from './ui-state.actions';

export interface UiState {
  screenType: 'desktop' | 'tablet' | 'mobile';
  leftColHidden: boolean;
  uploadPolicy?: UploadPolicy;
}

export const initialState: UiState = {
  screenType: 'desktop',
  leftColHidden: false,
};
export type ScreenType = 'desktop' | 'tablet' | 'mobile';

export const uiStateReducer = createReducer(
  initialState,
  on(UiActions.IsMobile, (state) => {
    return { ...state, screenType: 'mobile' as ScreenType };
  }),
  on(UiActions.IsTablet, (state) => {
    return { ...state, screenType: 'tablet' as ScreenType };
  }),
  on(UiActions.IsDesktop, (state) => {
    return { ...state, screenType: 'desktop' as ScreenType };
  }),
  on(UiActions.HideLeft, (state) => {
    return { ...state, leftColHidden: true };
  }),
  on(UiActions.ShowLeft, (state) => {
    return { ...state, leftColHidden: false };
  }),
  on(UiActions.setUploadPolicy, (state, policy) => ({
    ...state,
    isLoading: false,
    uploadPolicy: policy.policy,
  }))
);

export const getScreenType = (state: UiState) => state.screenType;
